import DoneIcon from 'material-ui/svg-icons/action/done'
import WarningIcon from 'material-ui/svg-icons/alert/warning'
import OptionalIcon from 'material-ui/svg-icons/toggle/radio-button-unchecked'
import DangerIcon from 'material-ui/svg-icons/content/clear'

export default {
  'danger': <DangerIcon color="#FF4141" />,
  'info': <DoneIcon color="#49A74C" />,
  'warning': <WarningIcon color="#FFBD36" />,
  'optional': <OptionalIcon color="#666" style={{ width: 24, height: 16 }} />,
}



// WEBPACK FOOTER //
// ./app/components/icons/SeverityIcons.js